const styles = (theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "20px",
      padding: "24px",
      maxWidth: "600px",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        margin: "16px",
        padding: "16px",
      },
    },
  },
  dialogTitle: {
    color: "white",
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "24px",
    padding: 0,
    "& .MuiTypography-root": {
      color: "white",
      fontSize: 22,
      fontWeight: 600,
    },
  },
  dialogContent: {
    padding: 0,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    "& .MuiFormControl-marginDense": {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      borderRadius: "8px",
      "&:hover fieldset": {
        borderColor: "#768FDD",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#768FDD",
      },
      "& input": {
        color: "white",
      },
      "& label": {
        color: "rgba(255, 255, 255, 0.7)",
        "&.Mui-focused": {
          color: "#768FDD",
        },
      },
    },
    "& .MuiInputBase-input": {
      color: "white",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.7)",
      "&.Mui-focused": {
        color: "#768FDD",
      },
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.3)",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: "rgba(255, 255, 255, 0.6)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#768FDD",
    },
  },
  accordion: {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    borderRadius: "8px",
    marginTop: "8px",
    "&.Mui-expanded": {
      margin: "8px 0 0",
    },
    "&:before": {
      display: "none",
    },
    "& .MuiAccordionSummary-root": {
      padding: "16px",
      "& .MuiTypography-root": {
        color: "white",
        fontWeight: 500,
      },
    },
    "& .MuiAccordionDetails-root": {
      padding: "16px",
    },
  },
  checkbox: {
    color: "#768FDD",
    "&.Mui-checked": {
      color: "#768FDD",
    },
    "&:hover": {
      backgroundColor: "rgba(118, 143, 221, 0.1)",
    },
  },
  checkboxLabel: {
    color: "white",
    "& .MuiTypography-root": {
      color: "white",
    },
  },
  select: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderRadius: "8px",
    width: "100%",
    minWidth: 200,
    "&.MuiInput-underline:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.3)",
    },
    "&.MuiInput-underline:after": {
      borderBottomColor: "#768FDD",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.2)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#768FDD",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#768FDD",
    },
    "& .MuiSelect-select": {
      color: "white",
    },
    "& .MuiSelect-icon": {
      color: "white",
    },
  },
  menuItem: {
    color: "#2A3142",
    "&:hover": {
      backgroundColor: "rgba(118, 143, 221, 0.1)",
    },
  },
  dialogActions: {
    padding: "24px 0 0 0",
    justifyContent: "flex-end",
    gap: "12px",
  },
  cancelButton: {
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #FFFFFF",
      outlineOffset: 2,
    },
  },
  submitButton: {
    backgroundColor: "#768FDD",
    color: "white",
    borderRadius: 8,
    padding: "8px 20px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#5A6DB6",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #FFFFFF",
      outlineOffset: 2,
    },
  },
  helperText: {
    color: "rgba(255, 255, 255, 0.7)",
    marginLeft: 8,
    marginTop: 4,
    fontSize: 12,
  },
  warningText: {
    color: "#FF8A8A",
    marginLeft: 8,
    marginTop: 4,
    fontSize: 12,
  },
  inputLabel: {
    color: "rgba(255, 255, 255, 0.7)",
    "&.Mui-focused": {
      color: "#768FDD",
    },
  },
  input: {
    color: "white",
  },
  selectContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
  },
});

export default styles;
